import { useMemo } from 'react';

import Typography from '@/components/typography';
import getDotColor from '@/features/comps/functions/getDotColor';
import { CardCloseButton } from '@/features/selectionsPanel/selectionCard/baseCard/cardCloseButton';
import { AcresFeature } from '@/models/features';
import { isCompFeature } from '@/models/features/guards';

import {
  formatAcres,
  getAcresOfSelectionsPanelFeature,
} from '../../util/determineSelectionsPanelAcres';
import { CardDot } from './cardDot';

type Props = {
  feature: AcresFeature;
  idx?: number;
  onClose: () => void;
};

export const CardTitle = ({ feature, onClose, idx = undefined }: Props) => {
  const acres = useMemo(
    () => getAcresOfSelectionsPanelFeature(feature),
    [feature]
  );
  const formattedAcres = useMemo(() => formatAcres(acres, false), [acres]);

  const isACompFeature: boolean = useMemo(
    () => isCompFeature(feature),
    [feature]
  );

  const cardDotColor = useMemo(() => {
    if (!isACompFeature || !feature?.properties) {
      return undefined;
    }

    if ('visibility' in feature.properties) {
      const compVisibility = feature.properties.visibility;
      return getDotColor(compVisibility);
    }
    return undefined;
  }, [feature.properties, isACompFeature]);

  return (
    <div className="flex flex-row items-center">
      <CardDot dotColor={cardDotColor} hideIdx={isACompFeature} idx={idx} />
      <Typography className="mr-1 leading-5" variant="h5">
        {formattedAcres}
      </Typography>
      <Typography className="leading-5">acres</Typography>
      <CardCloseButton className="ml-auto" onClick={onClose} />
    </div>
  );
};
